import { WebsiteTexts, WebsiteTextsChn } from 'assets/web-contents/TextItems';

const initTexts = (lang, page) => {
  let pgTxts = null;
  if (lang === 'English') {
    pgTxts = WebsiteTexts.filter((ti) => ti.page === page);
  } else {
    pgTxts = WebsiteTextsChn.filter((ti) => ti.page === page);
  }
  return pgTxts;
};
const _initTexts = initTexts;
export { _initTexts as initTexts };

const TimeOut = 5000;
const _TimeOut = TimeOut;
export { _TimeOut as TimeOut };

const openInNewTab = (url) => {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
};
const _openInNewTab = openInNewTab;
export { _openInNewTab as openInNewTab };
